import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { HttpClient } from "@angular/common/http";
import { DonacionModel } from "../shared/models/donacion-model";
@Injectable()
export class SectionsService extends BaseService {
  constructor(public http: HttpClient) {
    super(http);
  }


  /**
   * @author Jose Wilson Mulato
   * @description El sistema envia los datos para crear la donacion
   * @param data
   */
  public async saveDonacion(data: DonacionModel) {
    let url: string = `saveDonacion`;
    return this.Post(url, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sections.service.ts